<template>
  <div>
    <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="investReportTypeSelect"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
      v-if="showReportConfig('ShowasOfDate')">
        <v-col id="InvestReportFromDate">
          <ClarionDateControl
            v-model="criteria.asOfDate"
            :isToggle="false"
            :isRequired="true" label="As of Date" />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
       v-if="showReportConfig('showgroupCode')">
        <v-col>
          <MultiItemSelect id="mtg-report-by-GroupCode"
            label="Group Code"
            item-text="groupCode"
            item-value="groupCode"
            :item-list="groupCode"
            :items="criteria.groupCode"
            @selected-items="selectedGroupType"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
       v-if="showReportConfig('showInvestmentType')">
        <v-col>
          <MultiItemSelect id="invest-type"
            label="Type"
            item-text="description"
            item-value="name"
            :item-list ="investmentTypeEnumsList"
            :items="criteria.investmentType"
            @selected-items="selectedInvestmentType"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
       v-if="showReportConfig('showInvestmentFund')">
        <v-col>
          <MultiItemSelect id="invest-fund"
            label="GL Fund"
            item-text="fundDesc"
            item-value="_id"
            :item-list ="funds"
            :items="criteria.fundList"
            @selected-items="selectedFunds"
          />
        </v-col>
      </v-row>
      <v-row  class="elevation-1"
      v-if="showReportConfig('showmaturitydate')">
          <v-checkbox class="ml-4"
            v-model="criteria.sortByMaturityDate"
            label="Sort by Maturity Date"/>
      </v-row>
      <v-row  class="elevation-1"
      v-if="showReportConfig('showcombinedCDandCDAR')">
          <v-checkbox class="ml-4"
            v-model="criteria.combinedSubtotalCDandCDARS"
            label="CD/CDARS Combined Subtotal"/>
      </v-row>
        <v-row class="elevation-1"
         v-if="showReportConfig('showisPrint')">
       <v-checkbox class="ml-4"
        v-model="criteria.isPrintClose"
        label="Print Closed ?"
      />
      </v-row>
      <v-row  class="elevation-1"
      v-if="showReportConfig('showDescriptionOptions')">
          <v-checkbox class="ml-4"
            v-model="criteria.includeDescription"
            label="Include last description"
            @change="onIncludeDescriptionChange"/>
          <v-checkbox class="ml-4"
            v-model="criteria.printAllDescriptions"
            label="Include all description"
            @change="onPrintAllDescriptionsChange"/>
      </v-row>
      <v-row id="mtgViewReport">
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import MultiItemSelect from '@/components/common/base/MultiItemSelect.vue';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import ReportChip from '../../../reports/ReportChip.vue';
import { toShortDate, toFiscalYear } from '../../../../util/shared/tmc-global';
import { reportListInvest, queryStringCalc } from './report-utils';
import { getRawJwt } from '../../../../util/jwt';

const bankCrudKey = 'sharedBank';
const fundCrudKey = 'sharedFund';

export default {
  name: 'ReportInfoComp',
  components: {
    ReportChip,
    ClarionDateControl,
    MultiItemSelect,
  },
  data: () => ({
    criteria: {
      asOfDate: undefined,
      printDetails: false,
      sortByMaturityDate: false,
      combinedSubtotalCDandCDARS: false,
      includeDescription: false,
      printAllDescriptions: false,
      groupCode: [],
      investmentType: [],
      fundList: [],
      fiscalYear: '',
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allGroupCode: false,
      allInvestmentType: false,
      allFunds: false,
    },
    isPrintClose: false,
  }),
  created() {
    this.fiscalYear = toFiscalYear(new Date(this.todaysDate));
    this.criteria.asOfDate = toShortDate(this.todaysDate);
    this.loadbanksGroupCode();
    this.loadInvestmentType();
    this.loadFundList();
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'items']),
    ...mapGetters([
      'todaysDate',
    ]),
    ...mapState({
      investmentType: (state) => state.enums.GlInvestmentTypeEnum,
    }),
    reports() {
      return [
        ...reportListInvest(),
      ];
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        criteria: this.criteria,
        token: this.getAuthToken,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,

      });
    },
    getAuthToken() {
      return getRawJwt();
    },
    groupCode() {
      const bankObjs = this.items(bankCrudKey) || [];
      const filteredBankObjs = bankObjs.filter((obj) => obj.groupCode && obj.groupCode.trim() !== '');
      return [...filteredBankObjs];
    },

    validateCriteria() {
      let isValid = true;
      if (this.criteria.groupCode !== null) {
        isValid = false;
      }
      return isValid;
    },
    investmentTypeEnumsList() {
      if (!this.investmentType) {
        return [];
      }
      return this.investmentType;
    },
    funds() {
      const fundObjs = this.items(fundCrudKey) || [];
      if (!fundObjs) {
        return [];
      }
      const updatedFundObj = fundObjs
        .filter((f) => f.type !== 'COLLECTIONFUND') // Filter out COLLECTIONFUND types
        .map((f) => ({
          ...f,
          fundDesc: f.fund === '0000' ? f.description : `${f.fund} - ${f.description || ''}`,
        }));
      return [...updatedFundObj]; // { _id: null, fund: '', fundDesc: '' },
    },
  },

  methods: {
    ...mapActions('shared/bank', [
      'loadBanks',
    ]),
    ...mapActions('shared/fund', [
      'loadFunds',
    ]),
    mapCollectionVal(itemList, itemValue) {
      return [...(itemList || []).map((item) => item[`${itemValue}`])];
    },
    selectedGroupType(val) {
      this.criteria.groupCode = val;
    },
    selectedInvestmentType(val) {
      this.criteria.investmentType = val;
      const val2 = (val || []).length === this.investmentTypeEnumsList.length;
      this.criteriaStats.allInvestmentType = val2;
    },
    selectedFunds(val) {
      this.criteria.fundList = val;
      const val2 = (val || []).length === this.funds.length;
      this.criteriaStats.allFunds = val2;
    },
    loadbanksGroupCode() {
      this.criteriaStats.allGroupCode = true;
      this.loadBanks({
        criteria: {},
        baseCrudKey: bankCrudKey,
      });
    },
    loadInvestmentType() {
      this.criteria.investmentType = this.mapCollectionVal(this.investmentTypeEnumsList, 'name');
      this.criteriaStats.allInvestmentType = true;
    },
    showReportConfig(configField) {
      return this.reportConfig.filters[`${configField}`];
    },
    onIncludeDescriptionChange(val) {
      if (val) {
        this.criteria.printAllDescriptions = false;
      }
    },
    onPrintAllDescriptionsChange(val) {
      if (val) {
        this.criteria.includeDescription = false;
      }
    },
    loadFundList() {
      this.loadFunds({
        criteria: {
          fiscalYear: this.fiscalYear,
          sortBy: [
            {
              column: 'fund',
              direction: 'asc',
            },
          ],
        },
        baseCrudKey: fundCrudKey,
      }).then(() => {
        this.criteria.fundList = this.mapCollectionVal(this.funds, '_id');
        /* Set select-all */
        this.criteriaStats.allFunds = true;
      });
    },
  },
};

</script>
